export default "__VITE_ASSET__PiFWdDvU__"